module.exports = __webpack_public_path__ + "static/media/15_Laptop_Web.985114f8.png";